import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexColumn } from 'styles/layouts';

import { Card } from '../../BackgroundReplacer/styles';

export const OuterWrapper = styled(Card)`
  padding: 20px;
  height: 100%;

  ${QUERIES.largeTabletAndUp} {
    min-width: 432px;
  }
`;

export const InnerWrapper = styled(FlexColumn)<{
  disabled: boolean;
}>`
  position: relative;

  justify-content: space-between;
  align-items: center;

  padding-top: 54px;
  padding-bottom: 17px;

  background: #f3f5f780;
  height: 100%;

  html[data-theme='dark'] &&,
  .dark && {
    background: #191b1e80;
  }

  border: 1px dashed ${themeStyle.varInkLight};
  border-radius: ${themeStyle.radiusMedium};

  cursor: ${({ disabled }) => (disabled ? 'unset' : 'pointer')};

  transition: border-color 0.2s;

  ${QUERIES.largeTabletAndUp} {
    padding-top: 152px;
  }

  &.invalid {
    border-color: ${themeStyle.varAlertRed};
  }

  &:hover:not(.invalid),
  &.valid {
    border-color: ${({ disabled }) =>
      disabled ? undefined : themeStyle.varBlueMedium};
  }
`;

export const DragOverlay = styled.div`
  position: absolute;

  top: 0;
  left: 0;

  width: 100%;
  height: 100%;
`;
